export default "__VITE_ASSET__1oVXbRMB__"